import React from 'react';
import PageHeader from './components/PageHeader';
import { useNavigate } from 'react-router-dom';

function DesignHub() {
  const navigate = useNavigate();

  const tiles = [
    {
      path: '/design-hub/document-templates',
      label: 'Document Templates',
      icon: '📄',
      description: 'Word templates for invoices, quotes, job sheets, purchase orders, and other documents.',
    },
    {
      path: '/design-hub/pdf-templates',
      label: 'PDF Overlay Templates',
      icon: '🎯',
      description: 'Finished invoice PDFs with merge fields placed over the design.',
    },
    {
      path: '/design-hub/form-designer',
      label: 'Form Templates',
      icon: '📋',
      description: 'Build mobile form question lists and generated merge fields.',
    },
  ];

  const openTile = (item) => {
    if (item.disabled) return;
    navigate(item.path);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="Design Hub"
        subtitle="Document and form template tools"
        backTo="/dashboard"
        backLabel="Dashboard"
        sticky
      />

      <main className="max-w-6xl mx-auto px-6 py-8">
        <div className="bg-gray-300 rounded-lg shadow p-6 mx-auto" style={{ width: 'fit-content', maxWidth: '1200px' }}>
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Quick Access</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 justify-items-center">
            {tiles.map((item) => (
              <button
                key={item.path}
                onClick={() => openTile(item)}
                disabled={item.disabled}
                className={`flex flex-col items-center p-6 bg-white rounded-lg w-full max-w-xs border-2 border-black hover:border-blue-500 hover:shadow-lg transition-all group ${
                  item.disabled ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              >
                <span className="text-5xl mb-3 group-hover:scale-110 transition-transform">
                  {item.icon}
                </span>
                <h3 className="text-lg font-semibold text-gray-800 mb-2 text-center">{item.label}</h3>
                <p className="text-xs text-gray-500 text-center">{item.description}</p>
                {item.disabled && <span className="text-xs text-gray-400 mt-1">Coming soon</span>}
              </button>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}

export default DesignHub;
